import { VatRate } from '../types/vatRate'

export const getLocalVatRates = (vatRates: VatRate[]): VatRate[] =>
  vatRates.filter((vatRate) => vatRate.taxRateGroup === 'local')
